export const RightsKeys = {
	all: ["rights"] as const,
};
